import React from 'react'
import Routes from './Routes'
import { THEMES } from 'Lib'
import '../../../scss/index'

// require('../../../scss/styleCentral.scss')
// require('../../../scss/styleRoomminister.scss')
let style = ''
if (THEMES === 'central') {
    style = 'styleCentral'
} else if (THEMES === 'meetup') {
    style = 'styleMeetup'
} else {
    style = 'styleRoomminister'
}
require(`../../../scss/${style}.scss`)
// require(`../../../scss/styleCentral.scss`)


export default () => (
    <div className={THEMES}>
        <Routes />
    </div>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/App.js